import { Paths } from '@/app/paths';
import {
  ChatRequestSource,
  applyChatRequestAtom
} from '@/infrastructure/state/chatRequests';
import { useSetAtom } from 'jotai';
import { NavigateOptions, useNavigate } from 'react-router-dom';

import { AccommodationsSearchRequestDto } from '../AccommodationList/api/requestTypes';
import { FlightsRequest } from '../TransportList/api/requestTypes';

export enum RequestType {
  flight = 'flight',
  accommodation = 'accommodation'
}
const useHandleChatRequest = () => {
  const navigate = useNavigate();

  const applyChatRequest = useSetAtom(applyChatRequestAtom);

  const handleChatRequest = (
    chatRequest: {
      request_type: string;
      preferences: FlightsRequest | AccommodationsSearchRequestDto;
      requestId?: string;
    },
    source: ChatRequestSource = { source: 'agent' }
  ) => {
    const isRefinement = !!chatRequest.requestId;
    const requestId = chatRequest.requestId || `request-id-${Date.now()}`;
    const options: NavigateOptions = {
      state: { requestId: requestId, isRefinement }
    };
    const { request_type, preferences } = chatRequest;

    if (request_type === RequestType.accommodation) {
      fillTravelerDetails(preferences as AccommodationsSearchRequestDto);
    }
    
    applyChatRequest({ requestId, preferences, ...source });

    if (request_type === RequestType.flight) {
      navigate(Paths.AirTransport, options);
    } else if (request_type === RequestType.accommodation) {
      navigate(Paths.Accommodations, options);
    }
  };

  return { handleChatRequest };
};

const fillTravelerDetails = (
  accommodationPreferences: AccommodationsSearchRequestDto
) => {
  if (accommodationPreferences.travelers) {
    const travelers = accommodationPreferences.travelers;

    accommodationPreferences.rooms = travelers.length;
    accommodationPreferences.adults = travelers
      .flatMap(t => t.paxes)
      .filter(t => t.age >= 18).length;
    accommodationPreferences.children = travelers
      .flatMap(t => t.paxes)
      .filter(t => t.age < 18).length;
    accommodationPreferences.travelers = undefined;
  }
};

export default useHandleChatRequest;
